export class Storia{

    public uuid: string;
    public periodo: string;
    public titolo: string;
    public testo: string;
    public immagine:string;
    public path_immagine:string;
    public ordine:number; //orderBy
    public lang: string;

    constructor(){}
}